import React, { Fragment, useState } from 'react';
import Footer from '../../component/Other/Footer';
import Navbar from '../../component/Other/Navbar';
import Head from '../../component/Page/Head';

const Faq = () => {
  const [topic, setTopic] = useState(null);
  const [description, setDescription] = useState('');

  const topics = [
    { label: 'Gestionar cuenta', value: 'account' },
    { label: 'Reportar problema', value: 'bug' },
    { label: 'Otros', value: 'other' },
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!topic) {
      alert('Por favor selecciona un tema.');
      return;
    }
    if (!description.trim()) {
      alert('Por favor describe tu problema.');
      return;
    }
    const selectedTopicLabel = topics.find((t) => t.value === topic)?.label || 'Soporte Técnico';
    const email = 'soporte@listopago.com.co';
    const subject = encodeURIComponent(selectedTopicLabel);
    const body = encodeURIComponent(description);
    window.location.href = `mailto:${email}?subject=${subject}&body=${body}`;
    setTopic(null);
    setDescription('');
  };

  return (
    <Fragment>
      <div className="overflow-hidden">
        <div className="bg__blue-2">
          <Navbar />
          <Head title="Soporte" />
        </div>

        <section className="soporte-page">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <p className="medium font__size--16 text__16-1024 color__gray-1 lh-2 mb-2">
                  Describe tu problema o inquietud en detalle.
                </p>
                <p className="medium font__size--16 text__16-1024 color__gray-1 lh-2 mb-4">
                  También puedes escribirnos a{' '}
                  <a href="mailto:soporte@listopago.com.co" className="color__purple semi-bold">
                    soporte@listopago.com.co
                  </a>
                </p>

                <form onSubmit={handleSubmit}>
                  <label className="d-block semi-bold font__size--16 text__16-1024 mb-2" style={{ color: '#333' }}>
                    Selecciona un tema
                  </label>
                  <div className="d-flex flex-wrap mb-4" style={{ gap: '8px' }}>
                    {topics.map((t) => (
                      <button
                        key={t.value}
                        type="button"
                        className="btn rounded-pill px-3 py-2 semi-bold font__size--14 border"
                        style={{
                          backgroundColor: topic === t.value ? 'rgb(17, 112, 223)' : '#FAFCFF',
                          borderColor: topic === t.value ? 'rgb(17, 112, 223)' : '#E0E0E0',
                          color: topic === t.value ? '#fff' : '#333',
                        }}
                        onClick={() => setTopic(t.value)}
                      >
                        {t.label}
                      </button>
                    ))}
                  </div>

                  <label className="d-block semi-bold font__size--16 text__16-1024 mb-2" style={{ color: '#333' }}>
                    Descripción
                  </label>
                  <textarea
                    className="form-control rounded__12 mb-4"
                    rows={6}
                    placeholder="Cuéntanos más sobre tu problema"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    style={{
                      border: '1px solid #E0E0E0',
                      fontSize: '14px',
                      resize: 'vertical',
                    }}
                  />

                  <button
                    type="submit"
                    className="btn btn__purple color__white semi-bold font__size--16 rounded-pill px-5 py-3 w-100 w-md-auto shadow-sm"
                    style={{
                      boxShadow: '0 4px 12px rgba(17, 112, 223, 0.3)',
                    }}
                  >
                    Enviar
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </Fragment>
  );
};

export default Faq;
